import { render, staticRenderFns } from "./AddArtist.vue?vue&type=template&id=dff37eda"
import script from "./AddArtist.vue?vue&type=script&lang=js"
export * from "./AddArtist.vue?vue&type=script&lang=js"
import style0 from "./AddArtist.vue?vue&type=style&index=0&id=dff37eda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports